import { useState, useEffect } from "react";
import API from "../lib/api";
import { Switch } from "./ui/switch";
import { toast } from "sonner";
import { Prohibit } from "@phosphor-icons/react";

export const AutoSuspendToggle = () => {
  const [enabled, setEnabled] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    API.get("/scheduler/compliance-suspend-settings")
      .then(({ data }) => setEnabled(!!data.enabled))
      .catch(() => setEnabled(false));
  }, []);

  const toggle = async (val) => {
    setSaving(true);
    try {
      const { data } = await API.put("/scheduler/compliance-suspend-settings", { enabled: val });
      setEnabled(!!data.enabled);
      toast.success(val
        ? "Auto-suspend enabled — suppliers with expired documents will be placed on hold"
        : "Auto-suspend disabled");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed to update setting");
    } finally { setSaving(false); }
  };

  if (enabled === null) return null;
  return (
    <div className="border border-border rounded-md p-3 mb-4 flex items-center justify-between gap-3" data-testid="auto-suspend-card">
      <div className="flex items-center gap-2.5">
        <Prohibit size={18} className="text-red-500 shrink-0" />
        <div>
          <p className="text-sm font-semibold">Auto-suspend on expired documents</p>
          <p className="text-[11px] text-muted-foreground">
            Suppliers with lapsed compliance documents are put on hold for new work and emailed —
            reinstated automatically once renewed. Checked daily.
          </p>
        </div>
      </div>
      <Switch checked={enabled} onCheckedChange={toggle} disabled={saving} data-testid="auto-suspend-switch" />
    </div>
  );
};

export default AutoSuspendToggle;
